import { render, staticRenderFns } from "./Innovators.vue?vue&type=template&id=a6d62cac&"
import script from "./Innovators.vue?vue&type=script&lang=js&"
export * from "./Innovators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports